
import Vue from 'vue';
import _, {startCase} from 'lodash'
import { Component, Prop } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { Action, Getter } from 'vuex-class';
import store from '@/store';
import { Category, Layout } from '@/types/categories';
import MenuItemEditor from '@/components/Menu/MenuItemEditor.vue';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { Content } from '@/types/content';
import { IconLookup } from '@fortawesome/fontawesome-svg-core';
import ContentPreview from '@/components/Editor/ContentPreview.vue';
import BannerEditor from '@/components/Editor/BannerEditor.vue';
import CategoryMetaDataInput from '@/components/Category/CategoryMetaDataInput.vue';
import TwitterPreview from '@/components/Editor/TwitterPreview.vue';
import LinkedInPreview from '@/components/Editor/LinkedInPreview.vue';
import FacebookPreview from '@/components/Editor/FacebookPreview.vue';

type icon = { icon: string; name: string };
@Component({
  components: {
    BannerEditor,
    CategoryMetaDataInput,
    ContentPreview,
    FacebookPreview,
    LinkedInPreview,
    MenuItemEditor,
    TwitterPreview,
  },
})
export default class CategoryEditor extends Vue {
  @Prop() id!: string;
  @Getter('categories/layouts') layouts!: Layout[];
  @Getter('categories/category') category!: Category;
  @Getter('categories/categories') categories!: Category[];
  @Getter('content/content') content!: Content[];
  @Action('categories/getLayouts') getLayouts!: Function;
  @Action('notifications/addNotification') addNotification!: Function;

  tabs: number = 0;

  icons: icon[] = Object.values(fas).map((icon) => {
    return {
        icon: icon.prefix + ' fa-' + icon.iconName,
        name: icon.iconName,
      }
  });

  isSaving: boolean = false;

  previewDialog: boolean = false;

  get pageName() {
    const name = this.$route.name || undefined;
    return _.startCase(name) + (this.category.name ? ': ' + this.category.name : '');
  }

  get listLayouts(): Layout[] {
    const categoryLayouts = this.layouts.filter(
      layout => layout.type === 'category',
    );
    return _.orderBy(categoryLayouts, ['name'], ['asc']);
  }

  get pageLayouts(): Layout[] {
    const pageLayouts = this.layouts.filter(
      layout => layout.type === 'content',
    );
    return _.orderBy(pageLayouts, ['name'], ['asc']);
  }

  get orderedCategories(): Category[] {
    return _.orderBy(
      _.filter(this.categories, category => category.id !== this.category.id),
      ['name'],
      ['asc'],
    );
  }

  async beforeRouteEnter(to: Route, from: Route, next: Function) {
    if (to.params.id) {
      await store.dispatch('categories/getCategory', to.params.id);
      store.dispatch('content/getPage', { page: 1, category: to.params.id });
    } else {
      store.commit('categories/newCategory');
    }

    store.dispatch('categories/getLayouts');
    next();
  }

  async updateCategory() {
    this.isSaving = true;
    await store.dispatch('categories/saveCategory', this.category);
    this.isSaving = false;
    this.addNotification({
      text: 'Category saved',
      colour: 'green',
      top: true,
      right: true,
    });
  }
}
